import React from 'react';
import { getLevel, formatLevelBadge } from '../utils/levels';

type Props = {
  points: number;
};

const getBarStyle = (isLightTheme: boolean): React.CSSProperties => ({
  height: 8,
  background: isLightTheme ? 'rgba(156, 163, 175, 0.4)' : 'rgba(255,255,255,0.1)',
  borderRadius: 6,
  overflow: 'hidden',
});

const fillStyle = (pct: number): React.CSSProperties => ({
  width: pct + '%',
  height: '100%',
  background: 'linear-gradient(90deg, #5ac, #3ad)',
});

export const OrgPointsBadge: React.FC<Props> = ({ points }) => {
  const { level, nextThreshold, progressPct } = getLevel(points);
  const badge = formatLevelBadge(level);
  
  // Check if light theme
  const isLightTheme = document.documentElement.getAttribute('data-theme') === 'light';
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, color: isLightTheme ? '#1f2937' : 'rgba(255,255,255,0.9)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{
          display: 'inline-block',
          padding: '4px 8px',
          borderRadius: 6,
          background: isLightTheme ? 'rgba(156, 163, 175, 0.5)' : 'rgba(0,0,0,0.4)',
          border: isLightTheme ? '1px solid rgba(107, 114, 128, 0.3)' : '1px solid rgba(255,255,255,0.12)',
          color: isLightTheme ? '#000000' : 'rgba(255,255,255,0.95)',
          fontWeight: 600,
        }}>
          {badge} (Lvl {level})
        </span>
        <span style={{ opacity: 0.85, color: isLightTheme ? '#374151' : 'rgba(255,255,255,0.85)' }}>ORG Points: {points.toLocaleString()}</span>
        {nextThreshold !== null && (
          <span style={{ opacity: 0.85, color: isLightTheme ? '#374151' : 'rgba(255,255,255,0.85)' }}>Next: {nextThreshold.toLocaleString()}</span>
        )}
      </div>
      <div style={getBarStyle(isLightTheme)}>
        <div style={fillStyle(progressPct)} />
      </div>
    </div>
  );
};

export default OrgPointsBadge;
